import { render, staticRenderFns } from "./campainLayout.vue?vue&type=template&id=0b7a114c&scoped=true&"
import script from "./campainLayout.vue?vue&type=script&lang=js&"
export * from "./campainLayout.vue?vue&type=script&lang=js&"
import style0 from "./campainLayout.vue?vue&type=style&index=0&id=0b7a114c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7a114c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Footer: require('/app/components/partials/Footer.vue').default})
